var map = {
	"./alert-decagram-outline.svg": 754,
	"./chart-tree.svg": 777,
	"./chemical-weapon.svg": 173,
	"./close-circle-outline.svg": 444,
	"./folder-plus.1.svg": 973,
	"./infinity.svg": 316,
	"./pencil.svg": 383,
	"./plus-circle.1.svg": 394,
	"./progress-clock.svg": 420,
	"./timer-sand.svg": 130,
	"./trash.svg": 286,
	"./user.svg": 17
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 215;